var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextheightlarge = function SvgTextheightlarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.9h1.6V22H0V1.9zm12.2 13.2v-.5c-.3.4-.9.7-1.5.7-.7 0-1.6-.5-1.6-1.5s.9-1.5 1.6-1.5c.7 0 1.2.2 1.5.6v-.7c0-.6-.5-.9-1.1-.9-.5 0-1 .1-1.4.6l-.4-.9c.6-.5 1.2-.7 1.9-.7 1 0 1.9.4 1.9 1.7v3.1h-.9zm0-1v-.7c-.2-.3-.7-.5-1.1-.5-.6 0-1 .3-1 .8s.4.8 1 .8c.3.1.8-.1 1.1-.4zm2.3 1V8.7h1.1v2.4c.4-.5.9-.7 1.5-.7 1.2 0 2.1 1 2.1 2.4 0 1.5-.9 2.4-2.1 2.4-.7 0-1.1-.3-1.5-.7v.7h-1.1zm2.2-.8c.8 0 1.3-.7 1.3-1.5 0-.9-.5-1.5-1.3-1.5-.5 0-1 .3-1.2.7v1.8c.2.3.7.5 1.2.5zm3.1-1.5c0-1.4 1-2.4 2.4-2.4.9 0 1.4.4 1.8.8l-.7.6c-.2-.4-.7-.6-1-.6-.9 0-1.4.7-1.4 1.5s.6 1.5 1.4 1.5c.5 0 .8-.2 1-.6l.7.7c-.3.5-.9.8-1.8.8-1.4.2-2.4-.9-2.4-2.3z"
  })));
};
export { SvgTextheightlarge as ReactComponent };